// extracted by mini-css-extract-plugin
export default {"BooleanFeature":"wa_a bhs_b"};